<template>
  <div class="h-dialogContainer">
    <div class="row h-row-inputBox">
      <div class="col-sm-7 h-col-inputBox">
        <div class='h-inputLit'>
          <span>{{$t('MCS.groupNum')}}</span>
        </div>
        <input class="e-input" :value='groupid' disabled="true"/>
      </div>
    </div>
    <br>
    <div class="h-borderBox height-464">
      <div class="h-dialog-borderBox-topIcon">
        <div class="h-toolbarBg dialog-icon-style">
          <ejs-toolbar class="dialog-icon-style">
            <div class="dialog-icon-style" >
              <div>
                <button :title='$t("MCS.add")' class="e-tbar-btn e-control e-btn e-lib e-icon-btn dialog-icon-style" data-ripple="true" tabindex="-1" @click='addGroupMember'>
                  <span class="e-btn-icon icon hero-icon hero-icon-save e-icons"></span>
                </button>
              </div>
            </div>
          </ejs-toolbar>
        </div>
      </div>
      <div class="h-borderBox-content" style="overflow: hidden">
        <ejs-grid ref='grid' :dataSource="data" height='100%' :allowReordering='true' :allowResizing='true'>
          <e-columns>
            <e-column type='checkbox' headerText='mcsid' width='30' textAlign='Center'></e-column>
            <e-column field='userNum' clipMode='EllipsisWithTooltip' headerText='MC-ID' width='150' textAlign='Center'></e-column>
            <e-column field='participantType' clipMode='EllipsisWithTooltip' :valueAccessor='participantTypeFormatter' :headerText='$t("MCS.participantType")' width='150' textAlign='Center'></e-column>
          </e-columns>
        </ejs-grid>
      </div>
    </div>
    <div>
      <ejs-pager ref='pager' @click='getGridData()' :pageSize='page.pageSize' :currentPage='page.pageNo' :totalRecordsCount='page.totalCount' ></ejs-pager>
    </div>
    <CustomDialog ref='dialogPage' :element='dialogTip' :styles='styles'>
      <template v-slot:dialog-content>
        <DialogList ref='dialog' ></DialogList>
      </template>
    </CustomDialog>
  </div>
</template>

<script>

import commonJS from '../../common';
import CustomDialog from '../../../../common/CustomDialog';
import DialogList from '../../../util/tipDialog/DialogList';

export default {
  name: 'AddGroupMemberDialog',
  mixins: [commonJS],
  props: [
    'neid'
  ],
  components: {
    DialogList,
    CustomDialog
  },
  data() {
    return {
      data: {},
      groupid: '',
      page: {
        pageNo: '1',
        pageSize: '15',
        totalCount: '0',
        pageCount: '0',
      },
      vo: {
        flag: '',
        participantType: ''
      },
      dialogTip: {
        target: this.$refs.grouptable,
        refName: 'dialogList',
        buttonGroup: [
          { click: this.closeDialogListTipPage, buttonModel: { content: this.$t('MCS.cancle') } }
        ],
        title: this.$t('MCS.messageInfo'),
        isClose: true,
      },
    };
  },
  methods: {
    getGridData(groupid = this.groupid, neid = this.neid) {
      const $this = this;
      this.groupid = groupid;
      const vo = {
        flag: 0,
        participantType: 0
      };
      const params = {
        info: {
          neid: neid,
          msgid: this.msg.qryUsers
        },
        vo: vo,
        page: {
          pageNo: $this.$refs.pager.ej2Instances.currentPage,
          pageSize: this.page.pageSize
        }
      };
      this.$axios.post('/lte/ems/subscriber/mcs/requestCommon', params).then((response) => {
        const res = response.data.resultVal;
        $this.data = res.result;
        $this.page.totalCount = res.countrsp;
      });
    },

    addGroupMember() {
      const $this = this;
      const selectedRecords = this.$refs.grid.getSelectedRecords();
      if (selectedRecords.length < 1) {
        this.$toast('warning', this.$t('Common.tips.noSelect'));
        return;
      }
      const userNum = [];
      const mcname = [];
      const staticMap = new Map();
      const dynamicMap = new Map();
      selectedRecords.forEach((item) => {
        userNum.push(item.userNum);
        mcname.push(item.userAlias);
      });
      dynamicMap.set('mcid', userNum);
      dynamicMap.set('mcname', mcname);
      staticMap.set('groupid', this.groupid);
      staticMap.set('userpriority', 1);
      staticMap.set('participantType', '');
      staticMap.set('user_privilege', 0);
      const resObj = [];
      for (let i = 0; i < userNum.length; i++) {
        const resData = {};
        resData.operObj = userNum[i];
        resObj.push(resData);
      }
      const logArray = [];
      userNum.forEach((numItem) => {
        logArray.push({
          groupNum: $this.groupid,
          userNum: numItem
        })
      });
      const params = {
        info: {
          neid: this.neid,
          msgid: this.msg.addGroupMember,
          operation: 'bacthOperate'
        },
        vo: {
          0: {
            vo: this.voCycleSpell(staticMap, dynamicMap, userNum.length),
            info: {
              neid: this.neid,
              msgid: this.msg.addGroupMember,
              operation: 'bacthOperate',
              mcsFlag: true
            },
          }
        },
        log: {
          module: 'res.subscriber#res.subscriber_mcs#res.subscriber_mcs_group',
          execFunName: 'subscriber.addGroupMember',
          exectype: 1,
          execData: logArray
        }
      };
      this.$axios.post('/lte/ems/subscriber/mcs/requestCommon', params).then((response) => {
        resObj.forEach((item, index) => {
          item.operResult = response.data.resultVal[index].display;
          item.operCode = response.data.resultVal[index].code;
        });
        this.$refs.dialog.addOperetionResultList(resObj);
        $this.$refs.dialog.setTotalCount(mcname.length);
        $this.$refs.dialogPage.show();
      });
    },
    closeDialogListTipPage() {
      this.$refs.dialogPage.clear();
      this.$refs.dialogPage.close();
    },
  },
};
</script>

<style scoped>

</style>
